module.exports = __webpack_public_path__ + "static/media/gas.2a8abff6.svg";